import ToolPage from '@react/tools/components/ToolPage';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default ToolPage;

export async function getServerSideProps() {
  const { api, store } = createApiClient(apiEndpoints);
  try {
    await Promise.all(
      [
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        api.getToolsPage.asAction({
          'populate[seniorLivingTools][populate]': '*',
          'populate[checklists][populate]': 'mainImage',
          'populate[seniorLivingTypes][populate]': 'mainImg',
        }),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
